export const getFormattedFileSize = (fileSize)=>{
    if (fileSize <= 10) {
        return '< 0,01 MB';
    }
    return `${(fileSize / 1000).toFixed(2).replace('.', ',')} MB`;
};

//# sourceMappingURL=MDownloadItem.helpers.js.map